module.exports = __webpack_public_path__ + "static/img/redness-01.6a5c7de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/redness-01.jpg
// module id = 287
// module chunks = 1